import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, axiosInstance } from "lib";

export const getCountries = createAsyncThunk(
  "location/getCountries",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.Get_Country, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

export const getCountriesStates = createAsyncThunk(
  "location/getCountriesStates",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.Get_Country_States, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);
export const addSingleState = createAsyncThunk(
  "location/addSingleState",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.Add_Single_State, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);
export const addSingleCity = createAsyncThunk(
  "location/addSingleCity",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.Add_Single_City, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);
